import * as React from 'react'
import { tw } from 'utils/classnames'

export const toolRailClassName = tw(
  'flex h-[54px] w-full flex-row items-center gap-2 overflow-x-auto border-b border-cf-grey-200 bg-cf-grey-50 px-2',
  'md:absolute md:inset-0 md:h-auto md:w-auto md:flex-col md:overflow-y-auto md:overflow-x-hidden md:border-b-0 md:border-r md:py-3',
)

export function toolRailThumbClassName(isActive: boolean) {
  return tw(
    'relative block size-12 shrink-0 overflow-hidden rounded-lg border',
    isActive ? 'border-cf-purple-900 ring-2 ring-cf-purple-200' : 'border-cf-grey-200',
  )
}

export function ToolFrame({
  rail,
  children,
}: {
  rail: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <section className="grid min-h-[calc(100svh-6rem)] w-full grid-cols-1 grid-rows-[auto_1fr] md:grid-cols-[88px_minmax(0,1fr)] md:grid-rows-[1fr]">
      <div className="relative max-md:contents">{rail}</div>
      <div className="min-w-0">{children}</div>
    </section>
  )
}
